<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-19 15:33:29
 * @FilePath: 
 * @Description: 空白vue模板
-->
<template>
  <div style="min-height: 100vh; background: #f3f5f9">
    <img class="mini_bg_img" src="@/assets/images/member_register_bg.png" alt="" />
    <div class="member_form_con">
      <h4>会员信息填写</h4>

      <van-form @submit="onSubmit">
        <van-field v-model="formData.MemberName" maxlength="50" name="MemberName" label="会员姓名" placeholder="请输入姓名"
          :error="false" :rules="[{ required: true, message: '请输入姓名' }]" />
        <van-field name="SexId" label="会员性别">
          <template #input>
            <van-radio-group v-model="formData.SexId" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field readonly clickable name="Birthday" :value="formData.Birthday" label="会员生日" placeholder="请选择生日"
          @click="showBirthPicker = true" />
        <van-popup v-model="showBirthPicker" position="bottom" get-container="#app">
          <van-datetime-picker type="date" v-model="currentDate" :min-date="dateMinDate" :max-date="dateMaxDate"
            @confirm="onConfirm" @cancel="showBirthPicker = false" />
        </van-popup>
        <van-field v-model="formData.MobilePhone" disabled type="tel" name="MobilePhone" maxlength="11" label="手机号"
          placeholder="请输入手机号" :error="false" :rules="[{ required: true, message: '请输入手机号' }]">
        </van-field>

        <div style="margin: 16px">
          <van-button round block color="#333" native-type="submit" :disabled="isDisabled" :loading="isSubmiting"
            loading-text="提交中...">注册</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import {
  saveUserProfile,
  registerMiniMember,
  getMiniMemberInfo,
  getUserCardInfo,
} from "@/api/member";
import { dateFormat, handleLocalStorage } from "@/utils/index";
// import changeStore from "@/components/changeStore";
import { Dialog } from "vant";
import { setToken } from "@/utils/auth";
export default {
  name: "RegisteredMember",
  props: {},
  data() {
    return {
      vpnId: this.$store.state.vpnId,
      isDisabled: false,
      currentDate: new Date(),
      dateMinDate: new Date(1900, 0, 1),
      dateMaxDate: new Date(),
      formData: {
        MemberName: "",
        SexId: 1,
        MobilePhone: "",
        Birthday: "",
      },
      showBirthPicker: false,
      isSubmiting: false,
      returnurl: ''
    };
  },
  components: {
    // changeStore,
  },
  created() { },
  mounted() {
    this.phoneNum = this.$route.query.phone;
    this.formData.MobilePhone = this.phoneNum;
    this.returnurl = this.$route.query.returnurl;
    this.handleCheckIsMiniMember();
  },
  methods: {
    handleCheckIsMiniMember() {
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if (res.Code) {
          //
          this.handleGetMemberInfo();
        } else {
          if (res.Token) {
            setToken(res.Token);
          }
          this.isDisabled = true;
          this.$toast("您已注册微会员，请勿重复注册");
          setTimeout(() => {
            const backUrlObj = handleLocalStorage.get("registerAfterPage");
            handleLocalStorage.remove("registerAfterPage");
            if (this.returnurl && this.returnurl != undefined && (this.returnurl + '').length > 10) {
                  console.log("this.returnurl ==== "+this.returnurl)
              this.$router.replace(this.returnurl);
            } else {
              this.$router.replace(backUrlObj || "/homePage/homePage");
            }
          }, 2000);
        }
      });
    },
    // handleCloseStorePop() {},
    // clickStoreItem(item) {
    //   this.vpnId = item.Id;
    //   this.handleCheckIsMiniMember();
    // },
    handleGetMemberInfo(flag) {
      getMiniMemberInfo({ phone: this.phoneNum, vpnId: this.vpnId }).then(
        (res) => {
          console.log(res);
          if (res && !res.Code) {
            if (flag == "showInfo") {
              this.handleInitFormData(res);
            } else {
              Dialog.confirm({
                title: "提示",
                message:
                  "当前手机号查询到已有会员信息，是否直接使用原会员信息注册",
                cancelButtonText: "否",
                confirmButtonText: "是",
              })
                .then(() => {
                  // on confirm
                  this.handleInitFormData(res);
                })
                .catch(() => {
                  // on cancel
                });
            }
          }
        }
      );
    },
    handleInitFormData(res) {
      this.formData = {
        MemberName: res.MemberName,
        SexId: res.SexId,
        MobilePhone: res.MobilePhone,
        Birthday: res.Birthday ? res.Birthday.split(" ")[0] : "",
      };
      this.memberId = res.Id;
    },
    onConfirm(time) {
      this.formData.Birthday = dateFormat(time, "yyyy/MM/dd");
      this.showBirthPicker = false;
    },
    onSubmit(values) {
      console.log("submit", values);
      const param = {
        IsRegister: true,
        VpnId: this.vpnId,
        ProfileDTO: {
          Id: this.memberId,
          ...values,
        },
      };
      this.isSubmiting = true;
      saveUserProfile(param)
        .then((res) => {
          console.log("save返回数据");
          console.log(res);
          const profileId = res.ProfileId;
          const token = res.Token;
          if (token) {
            setToken(token);
          }
          const param2 = {
            ...param,
          };
          if (profileId) param2.ProfileDTO.Id = profileId;
          registerMiniMember(param2)
            .then((res) => {
              this.isSubmiting = false;
              if (res && typeof res == "string") {
                setToken(res);
                // this.$toast("注册成功");
                this.isDisabled = true;
                const backUrlObj = handleLocalStorage.get("registerAfterPage");
                handleLocalStorage.remove("registerAfterPage");
                if (this.returnurl && this.returnurl != undefined && (this.returnurl + '').length > 10) {
                    console.log("this.returnurl ==== "+this.returnurl)
                  this.$router.replace(this.returnurl);
                } else {
                  this.$router.replace(backUrlObj || "/homePage/homePage");
                }
              }
            })
            .catch(() => {
              this.isSubmiting = false;
            });
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.mini_bg_img {
  height: 340px;
}

.member_form_con {
  width: 80%;
  background: #fff;
  position: absolute;
  top: 230px;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px;
  border-radius: 15px;

  h4 {
    text-align: center;
  }
}
</style>
